<template>
    <div v-if="env !== 'production'">
        <p class="beta-tag">INT</p>
    </div>
</template>

<script>
    export default {
        name: "beta-tag",
        data() {
            return {
                env: process.env.NODE_ENV
            }
        }
    }
</script>

<style lang="scss" scoped>
    .beta-tag {
        display: inline-block;
        margin: 0 0 0 5px;
        padding: 1px 7px;
        background: none;
        color: $red;
        border-radius: 3px;
        text-transform: uppercase;
        font-size: 11px;
        border: 2px solid $red;
    }
</style>
